module.exports = __webpack_public_path__ + "img/banner_movil.c5d01201.jpg";